import React from 'react';
import AppointmentManager from './components/AppointmentManager';

const ManageAppointmentsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AppointmentManager />
    </div>
  );
};

export default ManageAppointmentsPage;